export const welcome = () => {
  console.log('%c Website by thibautcollin.be ', 'background: #000; color: #fff');
};
